
import React from "react";

// reactstrap components

// core components
import Navbar from "../components/Navbars/Navbar.js";
import IndexHeader from "../components/Headers/IndexHeader.js";

// others
import SimpleReactLightbox from "simple-react-lightbox";
import { ParallaxProvider } from 'react-scroll-parallax';

// Sections
import About from "../views/index/About.js";
import News from "../views/index/News.js";
import NewsCel from "../views/index/NewsCel.js";
import Trailers from "../views/index/Trailers.js";
import Requirements from "../views/index/Requirements.js";
import Download from "./index/Download.js";
import Footer from "./../components/Footers/Footer.js";

function Index() {

  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("index");
    return function cleanup() {
      document.body.classList.remove("index");
    };
  });

  return (
    <>
      <SimpleReactLightbox>
        <ParallaxProvider>
          <Navbar />
          <IndexHeader />
          <div className="main">
            <About />
            <div className="d-none d-sm-block">
              <div className="d-sm-none d-md-block" >
                <News />
              </div>
            </div>
            <NewsCel />
            <Trailers />
            <Requirements />
            <Download />
            <Footer />
          </div>
        </ParallaxProvider>
      </SimpleReactLightbox>
    </>
  );
}

export default Index;
